import { useUdsToken } from '@sunwebgroup/uds-ui/utils'
import useEmblaCarousel from 'embla-carousel-react'
import { useIntl } from 'react-intl'
import { useCMSPageField } from '@/cms/fields'
import styles from './Categories.module.css'
import { Category } from './Category'

export function Categories() {
  const ratingByFacility = useCMSPageField('userReviews.ratingByFacility')
  const intl = useIntl()
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    breakpoints: {
      [`(min-width: ${useUdsToken<string>('primitives_breakpoint_l_min')}px)`]: { active: false },
    },
  })

  return (
    <>
      {ratingByFacility && (
        <div className={styles.slider} ref={emblaRef}>
          <div className={styles.wrapper}>
            {ratingByFacility?.map((category) => {
              return (
                <Category
                  key={category.typeId}
                  icon={category.icon}
                  score={category.score}
                  label={intl.formatMessage({ id: `reviews_category_label_${category.typeId}` })}
                />
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}
